import ProductGroupingPartialsBack from "./ProductGroupingPartialsBack.component";

export default ProductGroupingPartialsBack;
